import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const ChatButton = ({ onClick }) => {
  return (
    <motion.button
      onClick={onClick}
      className={`fixed bottom-4 right-4 z-40 p-4 rounded-full shadow-lg bg-gradient-to-bl from-sky-400 to-blue-800 hover:opacity-90'}
        text-white transition-all duration-300`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <MessageCircle className="h-6 w-6" />
    </motion.button>
  );
};

export default ChatButton; 